export default "__VITE_ASSET__87b8af31__"